import React from 'react'
import { useDispatch } from 'react-redux'

import Arbiter from 'common/modules/arbiter'
import Internal from 'common/modules/internal'

import { RemoteMarkdown } from '@piconetworks/remote-markdown'

const Markdown = () => {
    const dispatch = useDispatch()

    const sendExternalLink = (href) => {
        dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...Arbiter.creators.sendExternalLink({
                    payload: href,
                }),
            },
        }))
    }

    return (
        <RemoteMarkdown
            url="https://s3.amazonaws.com/assets.trypico.com/gadget/kitchen-sink.md"
            onClickLink={sendExternalLink}
            options={{
                breaks: true,
            }}
        />
    )
}

export default Markdown
